import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function WhatsApp() {
  const phoneNumber = "+923070447737"; // Replace with actual number
  const message = "Hi Rahman! I'd like to discuss a project with you.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <Tooltip title="Chat on WhatsApp" placement="left">
      <Box
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1000,
        }}
      >
        <IconButton
          component="a"
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with Rahman Idrees on WhatsApp"
          sx={{
            width: 56,
            height: 56,
            background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
            boxShadow: "0 4px 20px rgba(37, 211, 102, 0.4)",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "scale(1.1)",
              boxShadow: "0 6px 30px rgba(37, 211, 102, 0.5)",
              background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
            },
          }}
        >
          <WhatsAppIcon sx={{ fontSize: 28, color: "white" }} />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

export default WhatsApp;
